'use client'

import React, { ReactNode } from 'react'
import { useEnvContext } from 'next-runtime-env'
import { useAuth } from '@/dc-shared-web/src'
import { useLDFlags } from '@/app/core/hooks/useLDFlags'
import Script from 'next/script'

type WithProviderContentProps = {
  children: ReactNode
}

// Source of the script from https://docs.usepylon.com/pylon-docs/in-app-chat/chat-setup
const PylonScript = () => {
  const { NEXT_PUBLIC_PYLON_APP_ID } = useEnvContext()

  return (
    <Script id='dc-pylon'>
      {`
        (function() {
          var e=window;var t=document;var n=function(){n.e(arguments)};n.q=[];n.e=function(e){n.q.push(e)};e.Pylon=n;var r=function(){var e=t.createElement("script");e.setAttribute("type","text/javascript");e.setAttribute("async","true");e.setAttribute("src","https://widget.usepylon.com/widget/${NEXT_PUBLIC_PYLON_APP_ID}");var n=t.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};if(t.readyState==="complete"){r()}else if(e.addEventListener){e.addEventListener("load",r,false)};

          window.pylon = {
            chat_settings: {
              app_id: '${NEXT_PUBLIC_PYLON_APP_ID}',
            },
          };
        })();
      `}
    </Script>
  )
}

function WithPylonProvider({ children }: WithProviderContentProps) {
  const { NEXT_PUBLIC_PYLON_ENABLED } = useEnvContext()
  const { isAuthenticating } = useAuth()
  const {
    flags: { rr1433PylonIntegration },
  } = useLDFlags()

  const shouldUsePylon =
    NEXT_PUBLIC_PYLON_ENABLED && !isAuthenticating && rr1433PylonIntegration

  return (
    <>
      {shouldUsePylon && <PylonScript />}
      {children}
    </>
  )
}

export default WithPylonProvider
